'use strict';

module.exports = {
  API: {
    facilities: {
      host: 'https://facilities.iyunbao.com'
    },
    api: {
      host: 'https://api.iyunbao.com'
    }
  },
  URL: {
    af: 'https://af.zhongan.io'
  }
};